import Icon from './../../../../assets/empty-states/global-error.svg?react';

export const GlobalErrorEmptyStateIcon = Icon;
